import { CheckDone01 } from '@kula-ai/icons/dual-tone/CheckDone01';
import { AlignLeft } from '@kula-ai/icons/dual-tone/AlignLeft';
import { Calendar } from '@kula-ai/icons/dual-tone/Calendar';
import { Calculator } from '@kula-ai/icons/outline/Calculator';
import { Dotpoints02 } from '@kula-ai/icons/outline/Dotpoints02';
import { CurrencyDollar } from '@kula-ai/icons/outline/CurrencyDollar';
import { SingleText } from '@kula-ai/icons/outline/SingleText';
import { CurrencyRange } from '@kula-ai/icons/outline/CurrencyRange';
import { Mail01 } from '@kula-ai/icons/outline/Mail01';
import { Phone } from '@kula-ai/icons/outline/Phone';
import { Upload04 } from '@kula-ai/icons/outline/Upload04';
import { Upload01 } from '@kula-ai/icons/dual-tone/Upload01';
import { AlignJustify } from '@kula-ai/icons/outline/AlignJustify';
import { ChevronSelectorVertical } from '@kula-ai/icons/outline/ChevronSelectorVertical';
import { Toggle02Left } from '@kula-ai/icons/dual-tone/Toggle02Left';
import { Link03 } from '@kula-ai/icons/dual-tone/Link03';
import { Location } from 'react-iconly';
import { Bs123 } from 'react-icons/bs';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { Bold02 } from '@kula-ai/icons/outline/Bold02';
import { Users01 } from '@kula-ai/icons/dual-tone/Users01';

/**
 * Maps a custom-field type/kind to its display icon.
 *
 * Relocated out of `pages/settings/ats/constants` so component-layer code
 * (e.g. filled application forms) can consume it without a components -> pages
 * boundary violation.
 */
export const customFieldsIconMap = {
  string: HiOutlineMenuAlt2,
  email: Mail01,
  phone: Phone,
  address: Location,
  rel_file: Upload01,
  singleText: SingleText,
  rel_file_multiple: Dotpoints02,
  complex: AlignJustify,
  rel_tag: ChevronSelectorVertical,
  rel_tag_multi: CheckDone01,
  rel_user: Users01,
  text: AlignLeft,
  currency: CurrencyDollar,
  number: Bs123,
  range: CurrencyRange,
  enum_boolean: Toggle02Left,
  radio2: CheckDone01,
  textArea: AlignLeft,
  url: Link03,
  date: Calendar,
  numberRange: Calculator,
  multiSelect: CheckDone01,
  integer: Dotpoints02,
  decimal: Bs123,
  composite: Dotpoints02,
  // VONQ Direct Apply question types
  choice: ChevronSelectorVertical,
  file: Upload04,
  textarea: AlignLeft,
  richtext: Bold02,
};
